<template>
  <div class="min-h-screen bg-gray-100 pb-20">
    <div class="max-w-[600px] mx-auto">
      
      <!-- Header -->
      <div class="bg-white sticky top-0 z-10 shadow-sm">
        <div class="flex items-center justify-between p-4">
          <button @click="$router.back()" class="p-1">
            <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
          </button>
          <h1 class="text-lg font-bold text-gray-800">{{ profile.username }}</h1>
          <router-link to="/settings" class="p-1">
            <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path>
            </svg>
          </router-link>
        </div>
      </div>

      <!-- Profil Bilgileri -->
      <div class="bg-white p-4">
        <div class="flex gap-4">
          <!-- Profil Resmi -->
          <div class="relative">
            <div class="w-24 h-24 rounded-full bg-gradient-to-br from-takas-sari to-yellow-400 flex items-center justify-center">
              <span class="text-4xl font-bold text-takas-koyu">{{ profileInitial }}</span>
            </div>
            <button class="absolute bottom-0 right-0 bg-takas-sari rounded-full p-1.5 shadow-lg">
              <svg class="w-3 h-3 text-takas-koyu" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
              </svg>
            </button>
          </div>
          
          <!-- İstatistikler (Takasla ilgili) -->
          <div class="flex-1 flex justify-around items-center">
            <div class="text-center">
              <div class="text-xl font-bold text-gray-800">{{ profile.totalListings }}</div>
              <div class="text-xs text-gray-500">Toplam İlan</div>
            </div>
            <div class="text-center">
              <div class="text-xl font-bold text-gray-800">{{ profile.activeListings }}</div>
              <div class="text-xs text-gray-500">Aktif İlan</div>
            </div>
            <div class="text-center">
              <div class="text-xl font-bold text-gray-800">{{ profile.totalOffers }}</div>
              <div class="text-xs text-gray-500">Teklif Aldı</div>
            </div>
          </div>
        </div>

        <!-- Kullanıcı Bilgileri -->
        <div class="mt-3">
          <div class="flex items-center gap-2">
            <h2 class="font-bold text-gray-800">{{ profile.fullName }}</h2>
            <span class="bg-blue-100 text-blue-600 text-xs px-2 py-0.5 rounded-full">Doğrulanmış</span>
          </div>
          <p class="text-sm text-gray-600 mt-1">{{ profile.bio }}</p>
          <div class="flex items-center gap-2 mt-2 text-xs text-gray-500">
            <div class="flex items-center gap-1">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
              </svg>
              <span>{{ profile.location }}</span>
            </div>
            <span>•</span>
            <div class="flex items-center gap-1">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
              <span>Katılım: {{ profile.joinDate }}</span>
            </div>
            <span>•</span>
            <div class="flex items-center gap-1">
              <svg class="w-3 h-3 text-takas-sari" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
              </svg>
              <span>{{ profile.successTrades }} başarılı takas</span>
            </div>
          </div>
        </div>

        <!-- Aksiyon Butonları -->
        <div class="flex gap-2 mt-4">
          <router-link to="/edit-profile" class="flex-1">
            <button class="w-full bg-takas-sari text-takas-koyu font-semibold py-2 rounded-lg text-sm">
              Profili Düzenle
            </button>
          </router-link>
          <router-link to="/add-listing" class="flex-1">
            <button class="w-full border border-gray-300 text-gray-700 font-semibold py-2 rounded-lg text-sm">
              İlan Ver
            </button>
          </router-link>
          <button class="px-4 border border-gray-300 rounded-lg">
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Tab Menü -->
      <div class="bg-white border-t border-gray-200">
        <div class="flex">
          <button 
            @click="activeTab = 'posts'"
            :class="[
              'flex-1 py-3 text-sm font-medium transition relative',
              activeTab === 'posts' ? 'text-takas-sari' : 'text-gray-500'
            ]"
          >
            <div class="flex items-center justify-center gap-1">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
              </svg>
              <span>İlanlar</span>
            </div>
            <div v-if="activeTab === 'posts'" class="absolute bottom-0 left-0 right-0 h-0.5 bg-takas-sari"></div>
          </button>
          
          <button 
            @click="activeTab = 'offers'"
            :class="[
              'flex-1 py-3 text-sm font-medium transition relative',
              activeTab === 'offers' ? 'text-takas-sari' : 'text-gray-500'
            ]"
          >
            <div class="flex items-center justify-center gap-1">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path>
              </svg>
              <span>Teklifler</span>
            </div>
            <div v-if="activeTab === 'offers'" class="absolute bottom-0 left-0 right-0 h-0.5 bg-takas-sari"></div>
          </button>
          
          <button 
            @click="activeTab = 'favorites'"
            :class="[
              'flex-1 py-3 text-sm font-medium transition relative',
              activeTab === 'favorites' ? 'text-takas-sari' : 'text-gray-500'
            ]"
          >
            <div class="flex items-center justify-center gap-1">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
              </svg>
              <span>Favoriler</span>
            </div>
            <div v-if="activeTab === 'favorites'" class="absolute bottom-0 left-0 right-0 h-0.5 bg-takas-sari"></div>
          </button>
        </div>
      </div>

      <!-- İçerik Alanı - İlanlar -->
      <div class="p-1">
        <div v-if="activeTab === 'posts'" class="grid grid-cols-3 gap-1">
          <div 
            v-for="post in userPosts" 
            :key="post.id"
            @click="goToListing(post.id)"
            class="aspect-square bg-gradient-to-br from-takas-sari/30 to-yellow-400/30 rounded-lg flex flex-col items-center justify-center cursor-pointer relative group"
          >
            <span class="text-3xl">{{ post.icon }}</span>
            <div class="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition flex items-center justify-center gap-3 rounded-lg">
              <div class="flex items-center gap-1 text-white">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                </svg>
                <span class="text-sm">{{ post.likes }}</span>
              </div>
              <div class="flex items-center gap-1 text-white">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4-.8L3 20l1.8-3.6A7.94 7.94 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
                </svg>
                <span class="text-sm">{{ post.offers }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Teklifler -->
        <div v-if="activeTab === 'offers'" class="p-4 space-y-3">
          <div v-for="offer in userOffers" :key="offer.id" class="bg-white rounded-xl p-3 flex gap-3">
            <div class="w-16 h-16 bg-gradient-to-br from-takas-sari/30 to-yellow-400/30 rounded-lg flex items-center justify-center">
              <span class="text-2xl">{{ offer.icon }}</span>
            </div>
            <div class="flex-1">
              <div class="flex justify-between">
                <h4 class="font-semibold text-sm">{{ offer.title }}</h4>
                <span :class="[
                  'text-xs px-2 py-0.5 rounded-full',
                  offer.status === 'accepted' ? 'bg-green-100 text-green-600' :
                  offer.status === 'pending' ? 'bg-yellow-100 text-yellow-600' : 'bg-red-100 text-red-600'
                ]">
                  {{ offer.status === 'accepted' ? 'Kabul Edildi' : offer.status === 'pending' ? 'Bekliyor' : 'Reddedildi' }}
                </span>
              </div>
              <p class="text-xs text-gray-500 mt-1">{{ offer.fromUser }} tarafından teklif edildi</p>
              <p class="text-xs text-gray-400 mt-1">{{ offer.date }}</p>
            </div>
          </div>
        </div>

        <!-- Favoriler -->
        <div v-if="activeTab === 'favorites'" class="grid grid-cols-3 gap-1 p-1">
          <div 
            v-for="fav in userFavorites" 
            :key="fav.id"
            @click="goToListing(fav.id)"
            class="aspect-square bg-gradient-to-br from-takas-sari/30 to-yellow-400/30 rounded-lg flex items-center justify-center cursor-pointer"
          >
            <span class="text-3xl">{{ fav.icon }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfilePage',
  data() {
    return {
      activeTab: 'posts',
      profile: {
        username: '@ahmet_yilmaz',
        fullName: 'Ahmet Yılmaz',
        bio: '📱 Teknoloji tutkunu | ♻️ Takas sever | İstanbul',
        location: 'İstanbul, Türkiye',
        joinDate: 'Aralık 2022',
        totalListings: 24,
        activeListings: 12,
        totalOffers: 45,
        successTrades: 28,
        avatar: null
      },
      userPosts: [
        { id: 1, icon: '📱', likes: 45, offers: 12 },
        { id: 2, icon: '💻', likes: 32, offers: 8 },
        { id: 3, icon: '🎮', likes: 28, offers: 5 },
        { id: 4, icon: '📚', likes: 15, offers: 3 },
        { id: 5, icon: '👕', likes: 22, offers: 7 },
        { id: 6, icon: '🪑', likes: 18, offers: 4 },
        { id: 7, icon: '🎸', likes: 12, offers: 2 },
        { id: 8, icon: '🚗', likes: 9, offers: 1 },
        { id: 9, icon: '🏺', likes: 7, offers: 0 }
      ],
      userOffers: [
        { id: 1, title: 'iPhone 13 Pro', icon: '📱', fromUser: 'Mehmet Demir', date: '10 Ocak 2024', status: 'pending' },
        { id: 2, title: 'MacBook Air', icon: '💻', fromUser: 'Ayşe Yılmaz', date: '5 Aralık 2023', status: 'accepted' },
        { id: 3, title: 'PlayStation 5', icon: '🎮', fromUser: 'Can Öztürk', date: '1 Ocak 2024', status: 'rejected' }
      ],
      userFavorites: [
        { id: 101, icon: '📱' },
        { id: 102, icon: '💻' },
        { id: 103, icon: '🎮' },
        { id: 104, icon: '📚' }
      ]
    }
  },
  computed: {
    profileInitial() {
      return this.profile.fullName.charAt(0).toUpperCase()
    }
  },
  methods: {
    goToListing(id) {
      this.$router.push(`/listing/${id}`)
    }
  }
}
</script>